/* eslint-disable react-hooks/exhaustive-deps */
import {useState, useEffect} from 'react'
import {initialQueryState, KTSVG, useDebounce, QUERIES} from '../../../../../_dashboard/helpers'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {useIntl} from 'react-intl'
import {getAll} from '../../../../services/common_requests'
import {useQuery} from 'react-query'

const ReservationsListSearchComponent = () => {
  const {updateState} = useQueryRequest()
  const intl = useIntl()

  const [searchTerm, setSearchTerm] = useState<string>('')
  const [statusFilter, setStatusFilter] = useState<string>('')
  const [paymentMethodFilter, setPaymentMethodFilter] = useState<string>('')
  const [checkInStartDate, setCheckInStartDate] = useState<string>('')
  const [checkInEndDate, setCheckInEndDate] = useState<string>('')
  const [startDate, setStartDate] = useState<string>('')
  const [endDate, setEndDate] = useState<string>('')

  const debouncedSearchTerm = useDebounce(searchTerm, 150)

  const {data: statusesResponse, isLoading: isStatusLoading} = useQuery(
    `${QUERIES.STATUSES_LIST}-statuses`,
    () => getAll('', '/status'),
    {cacheTime: 60 * 60 * 1000, staleTime: 30 * 60 * 1000},
  )

  const {data: paymentMethodsResponse, isLoading: isPaymentMethodLoading} = useQuery(
    `${QUERIES.PAYMENT_METHODS_LIST}-paymentMethods`,
    () => getAll('', '/payment-methods'),
    {cacheTime: 60 * 60 * 1000, staleTime: 30 * 60 * 1000},
  )

  const statuses = statusesResponse?.data || []
  const paymentMethods = paymentMethodsResponse?.data || []

  useEffect(() => {
    if (debouncedSearchTerm !== undefined && searchTerm !== undefined) {
      updateState({
        search: debouncedSearchTerm,
        status: statusFilter,
        paymentMethod: paymentMethodFilter,
        checkInDateStart: checkInStartDate,
        checkInDateEnd: checkInEndDate,
        startDate,
        endDate,
        ...initialQueryState,
      })
    }
  }, [
    debouncedSearchTerm,
    statusFilter,
    paymentMethodFilter,
    checkInStartDate,
    checkInEndDate,
    startDate,
    endDate,
  ])

  return (
    <div className='bo-filters d-flex flex-wrap gap-3 align-items-center flex-grow-1'>
      {/* Search */}
      <div className='position-relative d-flex align-items-center'>
        <KTSVG
          path='/media/icons/duotune/general/gen021.svg'
          className='svg-icon-2 position-absolute ms-4'
        />
        <input
          type='text'
          className='form-control form-control-solid w-200px w-lg-250px ps-12'
          placeholder={intl.formatMessage({id: 'COMMON.SEARCH'})}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Status */}
      <select
        className='form-select form-select-solid w-auto min-w-140px'
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
        disabled={isStatusLoading}
      >
        <option value=''>{intl.formatMessage({id: 'COMMON.ALL_STATUSES'})}</option>
        {statuses?.map((status: any) => (
          <option key={status._id} value={status._id}>
            {status.name}
          </option>
        ))}
      </select>

      {/* Payment method */}
      <select
        className='form-select form-select-solid w-auto min-w-160px'
        value={paymentMethodFilter}
        onChange={(e) => setPaymentMethodFilter(e.target.value)}
        disabled={isPaymentMethodLoading}
      >
        <option value=''>{intl.formatMessage({id: 'COMMON.ALL_PAYMENT_METHODS'})}</option>
        {paymentMethods?.map((pm: any) => (
          <option key={pm._id} value={pm._id}>
            {pm.code}
          </option>
        ))}
      </select>

      {/* Check-in range */}
      <div className='bo-date-range d-flex align-items-center gap-2'>
        <span className='text-muted fs-7 text-nowrap'>
          {intl.formatMessage({id: 'COMMON.CHECKIN_START'})}
        </span>
        <input
          type='date'
          className='form-control form-control-solid w-140px'
          value={checkInStartDate}
          onChange={(e) => setCheckInStartDate(e.target.value)}
        />
        <span className='text-muted fs-7'>→</span>
        <input
          type='date'
          className='form-control form-control-solid w-140px'
          value={checkInEndDate}
          onChange={(e) => setCheckInEndDate(e.target.value)}
        />
      </div>

      {/* Created-at range */}
      <div className='bo-date-range d-flex align-items-center gap-2'>
        <span className='text-muted fs-7 text-nowrap'>
          {intl.formatMessage({id: 'COMMON.CREATED_DATE_START'})}
        </span>
        <input
          type='date'
          className='form-control form-control-solid w-140px'
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <span className='text-muted fs-7'>→</span>
        <input
          type='date'
          className='form-control form-control-solid w-140px'
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </div>
    </div>
  )
}

export {ReservationsListSearchComponent}
